import JsBarcode from "jsbarcode";

/**
 * Generates an SVG HTML string representation of a Code 128 barcode using jsbarcode.
 */
export function generateCode128SvgHtml(text: string): string {
  try {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    JsBarcode(svg, text || "12345678", {
      format: "CODE128",
      displayValue: false,
      margin: 0,
      width: 2,
      height: 100,
    });
    svg.setAttribute("style", "width: 100%; height: 100%;");
    svg.setAttribute("preserveAspectRatio", "none");
    return svg.outerHTML;
  } catch (err) {
    console.error("Barcode generation failed:", err);
    return `<svg viewBox="0 0 100 100"><text y="50" fill="red">Barcode Error</text></svg>`;
  }
}

/**
 * Alias for generateCode128SvgHtml for backward compatibility.
 */
export const generateCode128SvgPath = generateCode128SvgHtml;
